module.exports = __webpack_public_path__ + "img/PurposeAndNeed_02_need.477fc080.jpg";